<div class="box-type-page core-screen">
  @if (loading()) {
  <div class="loading">
    <span>{{ 'common.loading' | translate }}</span>
  </div>
  } @else if (error()) {
  <div class="error">
    <span>{{ error() }}</span>
  </div>
  } @else if (boxType(); as bt) {
  <div class="box-type-content">
    <div class="box-type-header">
      <div class="box-type-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect
            x="3"
            y="3"
            width="18"
            height="18"
            rx="2"
            stroke="white"
            stroke-width="2"
          />
          <path d="M3 9h18M9 9v12" stroke="white" stroke-width="2" />
        </svg>
      </div>
      <div class="box-type-title">
        <h1 class="box-type-name">{{ bt.name }}</h1>
        <div class="box-type-status" [class.active]="bt.is_active">
          {{
            bt.is_active
              ? ('warehouse.status.active' | translate)
              : ('warehouse.status.inactive' | translate)
          }}
        </div>
      </div>
    </div>

    <div class="box-type-stats">
      <div class="stats-row stats-row--volume">
        <div class="stat-card stat-card--highlight">
          <span class="stat-value">{{ formatVolumeM3(bt) }}</span>
          <span class="stat-label">{{
            'admin.boxTypes.volumeM3' | translate
          }}</span>
        </div>
      </div>
      <div class="stats-row stats-row--sides">
        <div class="stat-card">
          <span class="stat-value">{{ bt.side1_mm }}</span>
          <span class="stat-label">{{ 'admin.boxTypes.side1' | translate }}</span>
        </div>
        <div class="stat-card">
          <span class="stat-value">{{ bt.side2_mm }}</span>
          <span class="stat-label">{{ 'admin.boxTypes.side2' | translate }}</span>
        </div>
        <div class="stat-card">
          <span class="stat-value">{{ bt.height_mm }}</span>
          <span class="stat-label">{{ 'admin.boxTypes.heightMm' | translate }}</span>
        </div>
      </div>
      <div class="stats-row stats-row--layers-weight">
        <div class="stat-card">
          <span class="stat-value">{{ bt.layers }}</span>
          <span class="stat-label">{{ 'admin.boxTypes.layers' | translate }}</span>
        </div>
        <div class="stat-card">
          <span class="stat-value">{{ bt.max_weight_kg }}</span>
          <span class="stat-label">{{ 'admin.boxTypes.maxWeight' | translate }}</span>
        </div>
      </div>
    </div>

    @if (bt.description) {
    <div class="description-card">
      <span class="description-label">{{
        'admin.boxTypes.description' | translate
      }}</span>
      <p class="description-text">{{ bt.description }}</p>
    </div>
    }

    <div class="info-card">
      <div class="toggle-row">
        <div class="toggle-info">
          <span class="toggle-label">{{
            'admin.boxTypes.activeStatus' | translate
          }}</span>
          <span class="toggle-description">
            {{
              bt.is_active
                ? ('admin.boxTypes.activeDescription' | translate)
                : ('admin.boxTypes.inactiveDescription' | translate)
            }}
          </span>
        </div>
        <label class="toggle-switch" [class.disabled]="isToggling()">
          <input
            type="checkbox"
            [checked]="bt.is_active"
            (change)="onToggleActive($event)"
            [disabled]="isToggling()"
          />
          <span class="slider"></span>
        </label>
      </div>
    </div>

    <div class="marking-card">
      <h2 class="marking-title">{{ 'admin.boxTypes.newBoxTitle' | translate }}</h2>
      <div class="marking-row">
        <lib-not-input
          label="admin.boxTypes.printLabels"
          type="text"
          mask="99"
          [ngModel]="labelCopiesStr()"
          (ngModelChange)="onLabelCopiesChange($event)"
        />
      </div>
      <lib-cabinet-button
        [type]="'button'"
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [disabled]="
          !canCreateAndPrint() || isCreatingBox() || printer.isPrinting()
        "
        [isLoading]="isCreatingBox() || printer.isPrinting()"
        [text]="'admin.boxTypes.createAndPrint'"
        [action]="{ type: 'action' }"
        (actionEvent)="onCreateAndPrint()"
      />
    </div>
  </div>
  }
</div>
